module.exports = __webpack_public_path__ + "583442575bce2c600034623eb7eb658d.svg";